module.exports = __webpack_public_path__ + "static/media/financeiro.42cbd73a.jpg";